import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Table,
  Badge
} from "reactstrap";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  students: any[];
  batchName: string;
}

const StudentHistoryModal: React.FC<Props> = ({
  isOpen,
  toggle,
  students,
  batchName
}) => {

  const totalFeesSum = students.reduce(
    (sum, s) => sum + Number(s.totalFees || 0),
    0
  );
// eslint-disable-next-line
  const totalPaidSum = students.reduce(
    (sum, s) => sum + Number(s.paidAmount || 0),
    0
  );

  const totalPendingSum = students.reduce(
    (sum, s) => sum + Number(s.pendingAmount || 0),
    0
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">

      {/* HEADER */}
      <ModalHeader
        toggle={toggle}
        style={{
          background: "linear-gradient(90deg,#374151,#093d92)",
          color: "#fff",
          borderBottom: "none"
        }}
      >
         {students[0]?.batchName || "Batch Students"}
      </ModalHeader>

      <ModalBody style={{ background: "#f4f6fb" }}>

        {/* ===== STUDENT TABLE ===== */}
        <Card
          className="border-0 shadow-sm mb-4"
          style={{ borderRadius: "16px" }}
        >
          <CardBody>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold mb-0">
            👨‍🎓 Batch Student List
</h6>

              <Badge color="primary" pill>
                {students.length} Students
              </Badge>
            </div>

            <Table
              responsive
              hover
              className="align-middle"
              style={{
                borderCollapse: "separate",
                borderSpacing: "0 8px"
              }}
            >
              <thead>
                <tr style={{ background: "#eef2f7" }}>
                  <th>Name</th>
                  <th>Course</th>
                  <th>Phone No</th>
                  <th>Total Fees</th>
                  <th>Pending</th>
                  <th>Next Due</th>
                </tr>
              </thead>

              <tbody>
                {students.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center text-muted py-4">
                      No Students Found
                    </td>
                  </tr>
                ) : (
                  students.map((s) => {
                    const totalFees = Number(s.totalFees || 0);
                    // eslint-disable-next-line
                    const paid = Number(s.paidAmount || 0);
                    const pending = Number(s.pendingAmount || 0);

                    const today = new Date();
                    const dueDate = s.nextDueDate ? new Date(s.nextDueDate) : null;

                    let statusText = "Pending";
                    let statusColor = "warning";

                    if (pending === 0) {
                      statusText = "Fully Paid";
                      statusColor = "success";
                    } else if (dueDate && dueDate < today) {
                      // eslint-disable-next-line
                      statusText = "Overdue";
                      // eslint-disable-next-line
                      statusColor = "danger";
                    }

                    return (
                      <tr
                        key={s.id}
                        style={{
                          background: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
                        }}
                      >
                        <td className="fw-semibold">{s.name}</td>

                        <td>{s.course}</td>

                        <td>{s.phoneNo}</td>

                        <td>₹{totalFees}</td>

                        

                        <td>
                          <Badge color="danger" pill>
                            ₹{pending}
                          </Badge>
                        </td>

                        <td>
                          {s.nextDueDate
                            ? new Date(s.nextDueDate).toLocaleDateString()
                            : "-"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>

          {/* FOOTER TOTAL */}
          <tfoot>
            <tr
              style={{
                fontWeight: 1000
              }}
            >
              <td></td>
              <td></td>
              <td>Total</td>
              <td>₹{totalFeesSum}</td>
              <td>₹{totalPendingSum}</td>
              <td colSpan={2}></td>
            </tr>
          </tfoot>

            </Table>

          </CardBody>
        </Card>

      </ModalBody>

    </Modal>
  );
};

export default StudentHistoryModal;